import constants from "../config/constants";
import { postRequest } from "../libs/AxiosService.util";

export async function serviceGetDoctorDashboardTotalReward(params) {
  return await postRequest("analytics/engagement/rewards/total", params);
}
export async function serviceGetDoctorDashboardCity(params) {
  return await postRequest("analytics/city/enrollment", params);
}
export async function serviceGetDoctorDashboardReward(params) {
  return await postRequest("analytics/doctor/stats", params);
}
export async function serviceGetDoctorDashboardEnrollment(params) {
  return await postRequest("analytics/enrollment/modes", params);
}
export async function serviceGetDoctorDashboardDrop(params) {
  return await postRequest("analytics/doctor/enrollment/trend", params);
}
export async function serviceGetHcpDoctorDashboardDrop(params) {
  return await postRequest("analytics/enrollment/trend", params);
}
export async function serviceGetDoctorDashboardCityWise(params) {
  return await postRequest("analytics/city/trend", params);
}
export async function serviceGetDoctorDashboardDoctorWise(params) {
  return await postRequest("analytics/doctor/trend", params);
}
export async function serviceGetDoctorDashboardMedicineRefill(params) {
  return await postRequest("analytics/doctor/medicine/trend", params);
}
export async function serviceGetHcpDoctorDashboardMedicineRefill(params) {
  return await postRequest("analytics/medicine/trend", params);
}
export async function serviceGetDoctorDashboardMedReminder(params) {
  return await postRequest("analytics/doctor/appointment/reminders", params);
}
export async function serviceGetDoctorDashboardTable(params) {
  return await postRequest("analytics/doctor/performance", params);
}
export async function serviceGetHcpDoctorDashboardTable(params) {
  return await postRequest("programs/patients", params);
}
export async function serviceGetAllDoctorDashboardTable(params) {
  return await postRequest("programs/sales-rep-doctor-mapping", params);
}
export async function serviceDoctorEnrollTrendExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/doctor/enrollment/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
export async function serviceDoctorMedicineTrendExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/doctor/medicine/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
export async function serviceGetPatientInsightsTable(params) {
  return await postRequest("programs/patients/insights", params);
}
export async function serviceGetAppointmentsTable(params) {
  return await postRequest("analytics/program/appointment", params);
}
export async function serviceGetDoctorRadarChart(params) {
  return await postRequest("analytics/engagement/count", params);
}
export async function serviceGetProgramPerfTable(params) {
  return await postRequest("analytics/program/performance", params);
}
export async function serviceGetModuleWiseTable(params) {
  return await postRequest("analytics/engagement/module/all", params);
}
export async function serviceGetMedicineTable(params) {
  return await postRequest("analytics/doctor/medicine/trend/product/recommendation", params);
}
export async function serviceMedicineRecTrendExport(params, token) {
  return await fetch(constants.DEFAULT_APP_URL + "analytics/doctor/medicine/trend/product/recommendation/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}

export async function servicePatientTableExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/doctor/patient/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
export async function serviceEnrollmentTrendExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/doctor/enrollment/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
export async function serviceDocMedicineTrendExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/doctor/medicine/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
export async function serviceAllDocExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"programs/sales-rep-doctor-mapping/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}